// Типы пулов «Настройки выдачи» — зеркалят backend (main_page_pools), в пакете типов их пока нет
export enum EMainPagePoolType {
  PRODUCTS = 'PRODUCTS',
  SELLER = 'SELLER'
}

// Приоритет выдачи товаров внутри пула
export enum EMainPagePoolPriority {
  RANDOM = 'RANDOM',
  PRICE_DESC = 'PRICE_DESC',
  PRICE_ASC = 'PRICE_ASC',
  BIG_DISCOUNT = 'BIG_DISCOUNT'
}

export interface IMainPagePoolProduct {
  _id: string
  name: string
  photo?: string[]
  price?: number
  article?: string
  status?: string
}

export interface IMainPagePoolSeller {
  _id: string
  shop_details?: { shop_name?: string }
  slug?: string
}

export interface IMainPagePool {
  _id: string
  position: number
  is_enabled: boolean
  type: EMainPagePoolType
  product_ids: IMainPagePoolProduct[]
  seller_id: IMainPagePoolSeller | null
  only_discounted?: boolean
  no_duplicate?: boolean
  priority?: EMainPagePoolPriority
  end_date?: string | null // «Дата окончания»: после неё пул выключается
}

export interface IUpdateMainPagePool {
  is_enabled?: boolean
  type?: EMainPagePoolType
  product_ids?: string[]
  seller_id?: string | null
  only_discounted?: boolean
  no_duplicate?: boolean
  priority?: EMainPagePoolPriority
  end_date?: string // YYYY-MM-DD
}
